import 'jquery.mb.ytplayer';

$(function(){
    $("#illumi-bg-movie").YTPlayer();
});
